import { options } from '../formatter-options'
import { truncateSelectedValues, formatSelectionsArray } from './utils'

export const getFormattedStoreLocations = (storeSelections: string[] = []) =>
  truncateSelectedValues(
    formatSelectionsArray(storeSelections, options.storeData),
  )
